/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgExtProfileResponseModel } from '../../models/org-ext-profile-response-model';

export interface OrgExtProfileOrganizationIdPersonIdGet$Params {
  organizationId: string;
  personId: string;
}

export function orgExtProfileOrganizationIdPersonIdGet(http: HttpClient, rootUrl: string, params: OrgExtProfileOrganizationIdPersonIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<OrgExtProfileResponseModel>> {
  const rb = new RequestBuilder(rootUrl, orgExtProfileOrganizationIdPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<OrgExtProfileResponseModel>;
    })
  );
}

orgExtProfileOrganizationIdPersonIdGet.PATH = '/OrgExt/Profile/{organizationId}/{personId}';
